import { render } from "./DbMathLevels.vue?vue&type=template&id=d8a2e16a&ts=true"
import script from "./DbMathLevels.vue?vue&type=script&lang=ts"
export * from "./DbMathLevels.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__